module.exports = __webpack_public_path__ + "img/hr-deepwater-outer-corner.065fda83.png";